<template>
  <div
    class="vs-component con-vs-checkbox"
    :class="[`vs-checkbox-${color}`, `vs-checkbox-${size}`, $attrs.class]"
    :style="$attrs.style"
  >
    <input
      class="vs-checkbox--input"
      type="checkbox"
      :checked="isChecked || $attrs.checked"
      :value="currentValue"
      v-bind="inputAttrs"
      @change="toggleValue"
    />
    <span class="checkbox_x vs-checkbox" :style="checkboxStyle">
      <span class="vs-checkbox--check" :style="checkStyle">
        <vs-icon
          class="vs-checkbox--icon"
          :icon="icon"
          :icon-pack="iconPack"
        />
      </span>
    </span>
    <span class="con-slot-label"><slot /></span>
  </div>
</template>

<script>
export default {
  name: "VsCheckbox",
  inheritAttrs: false,
  props: {
    modelValue: {
      default: undefined,
    },
    value: {
      default: undefined,
    },
    color: {
      type: String,
      default: "primary",
    },
    icon: {
      type: String,
      default: "check",
    },
    iconPack: {
      type: String,
      default: "material-icons",
    },
    vsValue: {
      type: [Boolean, Array, String, Number, Object],
      default: false,
    },
    size: {
      type: String,
      default: "default",
    },
  },
  emits: ["update:modelValue", "input", "change"],
  computed: {
    currentValue() {
      return this.modelValue !== undefined ? this.modelValue : this.value;
    },
    isChecked() {
      return Array.isArray(this.currentValue)
        ? this.currentValue.includes(this.vsValue)
        : Boolean(this.currentValue);
    },
    resolvedColor() {
      if (
        this.color.startsWith("#") ||
        this.color.startsWith("rgb") ||
        this.color.startsWith("hsl") ||
        this.color.startsWith("var(")
      ) {
        return this.color;
      }
      return `rgba(var(--vs-${this.color}), 1)`;
    },
    checkboxStyle() {
      return {
        border: `2px solid ${
          this.isChecked ? this.resolvedColor : "rgb(180, 180, 180)"
        }`,
      };
    },
    checkStyle() {
      return {
        background: this.isChecked ? this.resolvedColor : null,
      };
    },
    inputAttrs() {
      const attrs = { ...this.$attrs };
      ["class", "style", "checked", "onChange"].forEach(
        (key) => delete attrs[key]
      );
      return attrs;
    },
  },
  methods: {
    emitValue(value) {
      this.$emit("update:modelValue", value);
      this.$emit("input", value);
    },
    toggleValue(event) {
      if (Array.isArray(this.currentValue)) {
        const value = this.currentValue.slice();
        const index = value.indexOf(this.vsValue);
        if (index === -1) {
          value.push(this.vsValue);
        } else {
          value.splice(index, 1);
        }
        this.emitValue(value);
        this.$emit("change", value);
      } else if (typeof this.vsValue === "string") {
        const value =
          this.currentValue === this.vsValue ? null : this.vsValue;
        this.emitValue(value);
        this.$emit("change", value);
      } else {
        this.emitValue(!this.currentValue);
        this.$emit("change", event);
      }
    },
  },
};
</script>
